import AlertOutlineIcon from '@/assets/icons/alert-outline.svg?react';
import AlertIcon from '@/assets/icons/alert.svg?react';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import ArrowLeftAltIcon from '@/assets/icons/arrow-left-alt.svg?react';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';
import AssignIcon from '@/assets/icons/assign.svg?react';
import BabyIcon from '@/assets/icons/baby.svg?react';
import BankIcon from '@/assets/icons/bank.svg?react';
import BellIcon from '@/assets/icons/bell.svg?react';
import BlockIcon from '@/assets/icons/block.svg?react';
import BuildingsIcon from '@/assets/icons/buildings.svg?react';
import BulbIcon from '@/assets/icons/bulb.svg?react';
import CakeIcon from '@/assets/icons/cake.svg?react';
import CalendarBlankIcon from '@/assets/icons/calendar-blank.svg?react';
import CameraIcon from '@/assets/icons/camera.svg?react';
import CarSimpleIcon from '@/assets/icons/car-simple-outline.svg?react';
import CaretCircleLeftIcon from '@/assets/icons/caret-circle-left.svg?react';
import CaretCircleRightIcon from '@/assets/icons/caret-circle-right.svg?react';
import CaretDownIcon from '@/assets/icons/caret-down.svg?react';
import LogoCaymanLightIcon from '@/assets/icons/cayman-logo-white-text.svg?react';
import LogoCaymanIcon from '@/assets/icons/cayman-logo-with-text.svg?react';
import ChatDotsIcon from '@/assets/icons/chat-dots.svg?react';
import ChatEmptyIcon from '@/assets/icons/chat-empty.svg?react';
import ChatLinesIcon from '@/assets/icons/chat-lines.svg?react';
import CheckCircleOutlineIcon from '@/assets/icons/check-circle-outline.svg?react';
import CheckCircleIcon from '@/assets/icons/check-circle.svg?react';
import CheckFatOutlineIcon from '@/assets/icons/check-fat-outline.svg?react';
import CheckFatIcon from '@/assets/icons/check-fat.svg?react';
import CheckMiniIcon from '@/assets/icons/check-mini.svg?react';
import CheckSquareOffsetIcon from '@/assets/icons/check-square-offset.svg?react';
import CheckIcon from '@/assets/icons/check.svg?react';
import ChevronDoubleLeftIcon from '@/assets/icons/chevron-double-left.svg?react';
import ChevronDoubleRightIcon from '@/assets/icons/chevron-double-right.svg?react';
import ClockCountdownIcon from '@/assets/icons/clock-countdown.svg?react';
import CloseIcon from '@/assets/icons/close.svg?react';
import CopyIcon from '@/assets/icons/copy.svg?react';
import DeleteIcon from '@/assets/icons/delete.svg?react';
import DocumentTransparentIcon from '@/assets/icons/document-transparent.svg?react';
import DocumentIcon from '@/assets/icons/document.svg?react';
import DownloadIcon from '@/assets/icons/download.svg?react';
import DrivingLicenseIcon from '@/assets/icons/driving-license.svg?react';
import EditOutlineIcon from '@/assets/icons/edit-outline.svg?react';
import EmailIcon from '@/assets/icons/email.svg?react';
import EyeCloseIcon from '@/assets/icons/eye-close.svg?react';
import EyeOpenIcon from '@/assets/icons/eye-open.svg?react';
import FileDashIcon from '@/assets/icons/file-dash.svg?react';
import FileTextIcon from '@/assets/icons/file-text.svg?react';
import FileXIcon from '@/assets/icons/file-x.svg?react';
import FilesIcon from '@/assets/icons/files.svg?react';
import FilterOutlineIcon from '@/assets/icons/filter-outline.svg?react';
import FilterIcon from '@/assets/icons/filter.svg?react';
import FireSimpleIcon from '@/assets/icons/fire-simple.svg?react';
import GlassesIcon from '@/assets/icons/glasses.svg?react';
import GlobeSimpleIcon from '@/assets/icons/globe-simple.svg?react';
import GlobeIcon from '@/assets/icons/globe.svg?react';
import HandHeartIcon from '@/assets/icons/hand-heart.svg?react';
import HandshakeIcon from '@/assets/icons/handshake.svg?react';
import HouseIcon from '@/assets/icons/house.svg?react';
import IdentificationBadgeIcon from '@/assets/icons/identification-badge.svg?react';
import InfoOutlineIcon from '@/assets/icons/info-outline.svg?react';
import InfoIcon from '@/assets/icons/info.svg?react';
import ListMagnifyingGlassIcon from '@/assets/icons/list-magnifying-glass.svg?react';
import LockIcon from '@/assets/icons/lock.svg?react';
import LogoIcon from '@/assets/icons/logo.svg?react';
import MedalIcon from '@/assets/icons/medal.svg?react';
import MoneyIcon from '@/assets/icons/money.svg?react';
import MoreIcon from '@/assets/icons/more.svg?react';
import NoteIcon from '@/assets/icons/note.svg?react';
import PaperPlaneIcon from '@/assets/icons/paper-plane.svg?react';
import PasswordIcon from '@/assets/icons/password.svg?react';
import PhoneOutlineIcon from '@/assets/icons/phone-outline.svg?react';
import PhonePlusIcon from '@/assets/icons/phone-plus.svg?react';
import PhoneIcon from '@/assets/icons/phone.svg?react';
import PlusIcon from '@/assets/icons/plus.svg?react';
import PopcornIcon from '@/assets/icons/popcorn.svg?react';
import QuestionCircleIcon from '@/assets/icons/question-circle.svg?react';
import CloudReceiptIcon from '@/assets/icons/receipt-cloud.svg?react';
import ReceiptIcon from '@/assets/icons/receipt.svg?react';
import RejectIcon from '@/assets/icons/reject.svg?react';
import ScrollIcon from '@/assets/icons/scroll.svg?react';
import SearchDocIcon from '@/assets/icons/search-doc.svg?react';
import SearchTextIcon from '@/assets/icons/search-text.svg?react';
import SearchIcon from '@/assets/icons/search.svg?react';
import ShieldCheckIcon from '@/assets/icons/shield-check.svg?react';
import SignInIcon from '@/assets/icons/sign-in.svg?react';
import SignOutIcon from '@/assets/icons/sign-out.svg?react';
import SignatureIcon from '@/assets/icons/signature.svg?react';
import SirenIcon from '@/assets/icons/siren.svg?react';
import SpinnerIcon from '@/assets/icons/spinner.svg?react';
import StampIcon from '@/assets/icons/stamp.svg?react';
import StarIcon from '@/assets/icons/star.svg?react';
import StudentIcon from '@/assets/icons/student.svg?react';
import SuitcaseIcon from '@/assets/icons/suitcase.svg?react';
import ToolboxIcon from '@/assets/icons/toolbox.svg?react';
import UploadAltIcon from '@/assets/icons/upload-alt.svg?react';
import UploadIcon from '@/assets/icons/upload.svg?react';
import UserIcon from '@/assets/icons/user.svg?react';
import UsersIcon from '@/assets/icons/users.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';
import WrenchIcon from '@/assets/icons/wrench.svg?react';
import ZoomInIcon from '@/assets/icons/zoom-in.svg?react';
import ZoomOutIcon from '@/assets/icons/zoom-out.svg?react';

// prettier-ignore
export const APP_ICON_COMPONENTS = {
  'alert': AlertIcon,
  'alert-outline': AlertOutlineIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-left-alt': ArrowLeftAltIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'assign': AssignIcon,
  'baby': BabyIcon,
  'bank': BankIcon,
  'bell': BellIcon,
  'block': BlockIcon,
  'buildings': BuildingsIcon,
  'bulb': BulbIcon,
  'cake': CakeIcon,
  'calendar-blank': CalendarBlankIcon,
  'camera': CameraIcon,
  'car-simple-outline': CarSimpleIcon,
  'caret-circle-left': CaretCircleLeftIcon,
  'caret-circle-right': CaretCircleRightIcon,
  'caret-down': CaretDownIcon,
  'chat-dots': ChatDotsIcon,
  'chat-empty': ChatEmptyIcon,
  'chat-lines': ChatLinesIcon,
  'check': CheckIcon,
  'check-circle': CheckCircleIcon,
  'check-circle-outline': CheckCircleOutlineIcon,
  'check-fat': CheckFatIcon,
  'check-fat-outline': CheckFatOutlineIcon,
  'check-mini': CheckMiniIcon,
  'check-square-offset': CheckSquareOffsetIcon,
  'chevron-double-left': ChevronDoubleLeftIcon,
  'chevron-double-right': ChevronDoubleRightIcon,
  'clock-countdown': ClockCountdownIcon,
  'close': CloseIcon,
  'copy': CopyIcon,
  'delete': DeleteIcon,
  'document': DocumentIcon,
  'document-transparent': DocumentTransparentIcon,
  'download': DownloadIcon,
  'driving-license': DrivingLicenseIcon,
  'edit-outline': EditOutlineIcon,
  'email': EmailIcon,
  'eye-close': EyeCloseIcon,
  'eye-open': EyeOpenIcon,
  'file-dash': FileDashIcon,
  'file-text': FileTextIcon,
  'file-x': FileXIcon,
  'files': FilesIcon,
  'filter': FilterIcon,
  'filter-outline': FilterOutlineIcon,
  'fire-simple': FireSimpleIcon,
  'glasses': GlassesIcon,
  'globe': GlobeIcon,
  'globe-simple': GlobeSimpleIcon,
  'hand-heart': HandHeartIcon,
  'handshake': HandshakeIcon,
  'house': HouseIcon,
  'identification-badge': IdentificationBadgeIcon,
  'info': InfoIcon,
  'info-outline': InfoOutlineIcon,
  'list-magnifying-glass': ListMagnifyingGlassIcon,
  'lock': LockIcon,
  'logo': LogoIcon,
  'logo-cayman': LogoCaymanIcon,
  'logo-cayman-light': LogoCaymanLightIcon,
  'medal': MedalIcon,
  'money': MoneyIcon,
  'more': MoreIcon,
  'note': NoteIcon,
  'paper-plane': PaperPlaneIcon,
  'password': PasswordIcon,
  'phone': PhoneIcon,
  'phone-outline': PhoneOutlineIcon,
  'phone-plus': PhonePlusIcon,
  'plus': PlusIcon,
  'popcorn': PopcornIcon,
  'question-circle': QuestionCircleIcon,
  'receipt': ReceiptIcon,
  'receipt-cloud': CloudReceiptIcon,
  'reject': RejectIcon,
  'scroll': ScrollIcon,
  'search': SearchIcon,
  'search-doc': SearchDocIcon,
  'search-text': SearchTextIcon,
  'shield-check': ShieldCheckIcon,
  'sign-in': SignInIcon,
  'sign-out': SignOutIcon,
  'signature': SignatureIcon,
  'siren': SirenIcon,
  'spinner': SpinnerIcon,
  'stamp': StampIcon,
  'star': StarIcon,
  'student': StudentIcon,
  'suitcase': SuitcaseIcon,
  'toolbox': ToolboxIcon,
  'upload': UploadIcon,
  'upload-alt': UploadAltIcon,
  'user': UserIcon,
  'users': UsersIcon,
  'warning': WarningIcon,
  'wrench': WrenchIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
} as const;

export type AppIconName = keyof typeof APP_ICON_COMPONENTS;

export function getAppIconComponent(name: AppIconName) {
  return APP_ICON_COMPONENTS[name] || null;
}
